import Lista from './Lista';

export const BancoLista = Lista;
